// @flow

import React, { Component } from 'react';

import I18n from 'PMT/i18n/I18n';

import SessionAction from '../../actions/SessionAction';

class LogoutPage extends Component {

  componentDidMount() {
    SessionAction.logout();
  }

  render() {
    return (
      <div className="logout_page text-center">
        <h3 className="top-buffer-50 text-center">
          {I18n.tr('logout.redirect_message')}
        </h3>
      </div>
    );
  }

}

export default LogoutPage;
